var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#d73333ff",
    height: "70px",
    width: "70px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-40 -40 480.00 480.00",
    xmlSpace: "preserve",
    transform: "matrix(-1, 0, 0, 1, 0, 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-40, -40), scale(30)",
    fill: "#bbeca2",
    d: "M9.166.33a2.25 2.25 0 00-2.332 0l-5.25 3.182A2.25 2.25 0 00.5 5.436v5.128a2.25 2.25 0 001.084 1.924l5.25 3.182a2.25 2.25 0 002.332 0l5.25-3.182a2.25 2.25 0 001.084-1.924V5.436a2.25 2.25 0 00-1.084-1.924L9.166.33z",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M360,48H40C18,48,0,66,0,88v224c0,22,18,40,40,40h320c22,0,40-18,40-40V88C400,66,382,48,360,48z M256,336H40 c-13.2,0-24-10.8-24-24V88c0-13.2,10.8-24,24-24h216V336z M384,312c0,13.2-10.8,24-24,24h-88V64h88c13.2,0,24,10.8,24,24V312z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,108h8c4.4,0,8-3.6,8-8c0-4.4-3.6-8-8-8h-8c-4.4,0-8,3.6-8,8C40,104.4,43.6,108,48,108z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,108h8c4.4,0,8-3.6,8-8c0-4.4-3.6-8-8-8h-8c-4.4,0-8,3.6-8,8C76,104.4,79.6,108,84,108z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,108h8c4.4,0,8-3.6,8-8c0-4.4-3.6-8-8-8h-8c-4.4,0-8,3.6-8,8C112,104.4,115.6,108,120,108z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,116h-28c-4.4,0-8,3.6-8,8c0,4.4,3.6,8,8,8h28c4.4,0,8-3.6,8-8C348,119.6,344.4,116,340,116z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,156h-28c-4.4,0-8,3.6-8,8c0,4.4,3.6,8,8,8h28c4.4,0,8-3.6,8-8C348,159.6,344.4,156,340,156z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,196h-28c-4.4,0-8,3.6-8,8c0,4.4,3.6,8,8,8h28c4.4,0,8-3.6,8-8C348,199.6,344.4,196,340,196z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebar);
export default __webpack_public_path__ + "static/media/sidebar.963c8fe1c815907d84f3d6cdf96ee6a0.svg";
export { ForwardRef as ReactComponent };